<script setup lang="ts">

import type {Goal} from '@/ts/types/dto/interventions-dto';
import SvgIllustration from '@/vue/atoms/svg-illustration.vue';

defineProps<{
  goal: Goal;
  order: number;
  finished?: boolean;
  hideDescription?: boolean;
}>();
</script>
<template>
  <div class="goal" :class="{finished}">
    <div class="goal-heading">
      <span class="order">{{ order }}</span>
      <svg-illustration v-if="finished" name="check.svg"/>
    </div>
    <div class="headGoal">
      {{ goal.name }}
    </div>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span v-if="!hideDescription" v-safe-html="goal.descriptionHTML" class="body"/>
    <div class="q-mt-auto"/>
  </div>
</template>
<style scoped lang="scss">
.goal {
  width: 240px;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: var(--Spacing-spacing-8) var(--Spacing-spacing-7) var(--Spacing-spacing-9) var(--Spacing-spacing-6);
  @include q-card-20;
  @include screen-md {
    min-height: 400px;
  }
  @include screen-lg {
    width: 320px;
  }

  &.finished {
    @include q-card-dark-completed;

    .goal-heading,
    .headGoal,
    .body {
      color: var(--Light-Scheme-Neutral-UI-neutral-ui-0);
    }
  }
}

.goal-heading {
  @include font-metric-lg;
  color: var(--Neutral-UI-neutral-ui-100);
  display: flex;
  justify-content: space-between;
  padding-bottom: var(--Spacing-spacing-2);
  @include screen-md {
    padding-bottom: var(--Spacing-spacing-3);
  }
}

.headGoal {
  @include font-body-bold;
  padding-bottom: var(--Spacing-spacing-2);
  @include screen-md {
    padding-bottom: var(--Spacing-spacing-3);
  }
}

.body {
  @include font-body-sm;
}
</style>
